// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__EcPdt","slick-next":"CustomSlider_slick-next__Dt-ci"};